/**
 validation utility
 @packageDocumentation
 */

/**
 * ip address 유효성을 확인한다.
 * ip address는 xxx.xxx.xxx.xxx 형태로 표시하여야 한다.
 * @param value
 */
export const ipAddress = (value: string) => {
  const regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
  return regex.test(value)
}

/**
 * 사업자 번호 유효성을 확인한다.
 * @param value
 */
export const corpReisterNum = (value: string) => {
  const valueMap = value
    .replace(/-/gi, '')
    .split('')
    .map(function (item) {
      return parseInt(item, 10)
    })

  if (valueMap.length === 10) {
    const multiply = [1, 3, 7, 1, 3, 7, 1, 3, 5]
    let checkSum = 0

    for (let i = 0; i < multiply.length; ++i) {
      checkSum += multiply[i] * valueMap[i]
    }

    // @ts-ignore
    checkSum += parseInt((multiply[8] * valueMap[8]) / 10, 10)
    return Math.floor(valueMap[9]) === 10 - (checkSum % 10)
  }

  return false
}

/**
 * 이메일 주소 유효성을 확인
 */
export const email = (value: string) => {
  const regex = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/;
  return regex.test(value);
}